<template>
  <div>
    <h5 class="info-text">商店資訊</h5>
    
    <div class="row justify-content-center">
      <div class="col-md-12">
        <!-- <card>
          <template slot="header">
            <h4 class="card-title">{{editData.name}}</h4>
          </template>
          <div>
            <form method="get" action="/" class="form-horizontal"> -->
              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">申請人Email*</label>
                    <div class="col-sm-8">
                      <fg-input name="bossEmail" placeholder="Email" v-model="editData.bossEmail" v-validate="editDataValidations.bossEmail" :error="getError('bossEmail')">
                        <!-- <span
                          slot="helpBlock"
                          class="form-text"
                        >A block of help text that breaks onto a new line.</span>-->
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">申請人電話*</label>
                    <div class="col-sm-8">
                      <fg-input name="bossPhone" type="tel" placeholder="Phone" v-model="editData.bossPhone" v-validate="editDataValidations.bossPhone" :error="getError('bossPhone')">
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店統編</label>
                    <div class="col-sm-8">
                      <fg-input name="invoice" type="tel" placeholder="Invoice" v-model="editData.invoice" v-validate="editDataValidations.invoice" :error="getError('invoice')">
                      </fg-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店名稱*</label>
                    <div class="col-sm-8">
                      <fg-input name="name" type="tel" placeholder="Name" v-model="editData.businessName" v-validate="editDataValidations.businessName" :error="getError('name')">
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店Email*</label>
                    <div class="col-sm-8">
                      <fg-input name="email" placeholder="Email" v-model="editData.email" v-validate="editDataValidations.email" :error="getError('email')">
                        <!-- <span
                          slot="helpBlock"
                          class="form-text"
                        >A block of help text that breaks onto a new line.</span>-->
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店電話*</label>
                    <div class="col-sm-8">
                      <fg-input name="phone" type="tel" placeholder="Phone" v-model="editData.phone" v-validate="editDataValidations.phone" :error="getError('phone')">
                      </fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-4 col-form-label">商店地址*</label>
                <div class="col-sm-8">
                  <fg-input name="address" placeholder="Address" v-model="editData.address" v-validate="editDataValidations.address" :error="getError('address')">
                  </fg-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-4 col-form-label">Wifiotg Business ID*</label>
                <div class="col-sm-8">
                  <fg-input name="shopId" placeholder="" v-model="editData.shopId">
                    <!-- <span
                      slot="helpBlock"
                      class="form-text"
                    >A block of help text that breaks onto a new line.</span>-->
                  </fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <label class="col-sm-4 col-form-label">是否啟用線上支付</label>
                  <n-switch v-model="editData.isMobilePayment">
                    <i class="now-ui-icons ui-1_check" slot="on"></i>
                    <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                  </n-switch>
                </div>
                <div class="col-sm-6">
                  <label class="col-sm-4 col-form-label">是否啟用lala外送</label>
                  <n-switch v-model="editData.isLala">
                    <i class="now-ui-icons ui-1_check" slot="on"></i>
                    <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                  </n-switch>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否啟用內用</label>
                    <n-switch v-model="editData.isEatIn">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否內用現金付款</label>
                    <n-switch v-model="editData.isEatInCash">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否內用線上支付</label>
                    <n-switch v-model="editData.isEatInPay">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否啟用外帶</label>
                    <n-switch v-model="editData.isToGo">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否外帶現金付款</label>
                    <n-switch v-model="editData.isToGoCash">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否外帶線上支付</label>
                    <n-switch v-model="editData.isToGoPay">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否啟用外送</label>
                    <n-switch v-model="editData.isDelivery">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否外送現金付款</label>
                    <n-switch v-model="editData.isDeliveryCash">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">是否外送線上支付</label>
                    <n-switch v-model="editData.isDeliveryPay">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-4 col-form-label">營業資訊</label>
                <div class="col-sm-8">
                  <fg-input placeholder="營業時間Ex:上午11:00-14:00，下午17:00-22:00" v-model="editData.storeInfo">
                    <!-- <span
                      slot="helpBlock"
                      class="form-text"
                    >A block of help text that breaks onto a new line.</span>-->
                  </fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">FB粉專連結</label>
                    <div class="col-sm-8">
                      <fg-input placeholder v-model="editData.FBUrl"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">Google Review連結</label>
                    <div class="col-sm-8">
                      <fg-input placeholder v-model="editData.googleReviewUrl"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">餐點準備時間（分鐘）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="餐點準備時間Ex 10" v-model="editData.waitingTime"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">上架商品重置時間</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="上架商品重置時間Ex 00:10:00" v-model="editData.resetTime"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">最低外送金額（元）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="餐點準備時間Ex 10" v-model="editData.deliveryAmtTh"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">最少外送數量（項）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="上架商品重置時間Ex 00:10:00" v-model="editData.deliveryQtyTh"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">最長外送距離（公里）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="上架商品重置時間Ex 00:10:00" v-model="editData.deliveryDistanceTh"></fg-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">點餐時間間距（分鐘）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="點餐時間間距Ex 10(分鐘)" v-model="editData.timeSectorLength"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">系統點餐時間（小時-小時,天數）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="" v-model="editData.timeSetting"></fg-input>
                      <span
                          slot="helpBlock"
                          class="form-text"
                        >假如點餐時間為09:00~14:30，開放預約明天，則小時-小時為9-14.5，天數為2，即9-14.5,2</span>
                    </div>
                  </div>
                </div>
              </div>
              
            <!-- </form>
            <div class="row justify-content-md-center">
              <div class="col-md-3">
                <n-button native-type="button" type="gray" @click.native="home()">
                  回商店列表
                </n-button>
              </div>
              <div class="col-md-3">
                <n-button native-type="button" type="primary" @click.native="_editData()">
                  確認修改
                </n-button>
              </div>
            </div>
          </div>
        </card> -->
        <!-- end card -->
      </div>
    </div>
    選擇SI
    <el-select class="select-danger" placeholder="請選擇" v-model="selectedSi">
      <el-option v-for="option in siAccounts" class="select-danger" :value="option.value" :label="option.label" :key="option.label">
      </el-option>
    </el-select>
  </div>
</template>
<script>
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import {Select, Option} from 'element-ui';
import { fetchSiAccounts } from "../../../../javascripts/generalPages/fetchData";

export default {
  components: {
    Checkbox,
    Radio,
    FgInput,
    [Switch.name]: Switch,
    [Select.name]: Select,
    [Option.name]: Option
  },
  created: function() {
    fetchSiAccounts()
      .then(res => {
        this.siAccounts = res.data.map(d => {
          return {
            value: d.id,
            label: d.name
          };
        });
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      model: {
        design: true,
        code: false,
        develop: false
      },
      editData: {
        bossEmail: "",
        bossPhone: "",
        businessName: "",
        email: "",
        phone: "",
        address: "",
        shopId: "",
        storeInfo: "",
        isMobilePayment: false,
        isLala: false,
        isEatIn: false,
        isEatInCash: true,
        isEatInPay: false,
        isToGo: false,
        isToGoCash: false,
        isToGoPay: false,
        isDelivery: false,
        isDeliveryCash: false,
        isDeliveryPay: false,
        FBUrl: "",
        googleReviewUrl: "",
        waitingTime: 10,
        resetTime: "00:10:00",
        deliveryAmtTh: 0,
        deliveryQtyTh: 0,
        deliveryDistanceTh: 3,
        timeSectorLength: 15,
        timeSetting: "0-24,1",
      },
      editDataValidations: {
        businessName: {
          required: true,
          max: 20
        },
        email: {
          required: true,
          email: true,
          max: 50
        },
        phone: {
          required: true,
          max: 20
        },
        address: {
          required: true,
          max: 100
        },
        bossEmail: {
          required: true,
          email: true,
          max: 50
        },
        bossPhone: {
          required: true,
          max: 20
        },
        invoice: {
          required: false,
          max: 8
        }

      },
      siAccounts: [],
      selectedSi: ""
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.editData.siAccountId = this.selectedSi;
        this.$emit("on-validated", res, this.editData);
        return res;
      });
    }
  }
};
</script>
<style>
</style>
